{
	"type": "circle",
	"minzoom": 7,
	"layout": {
		"circle-sort-key": [
			"match",
			["get", "degree_of_crash___detailed"],
			"Fatal",
			5,
			"Serious injury",
			4,
			"Moderate injury",
			3,
			"Minor/Other Injury",
			2,
			0
		]
	},
	"paint": {
		"circle-stroke-width": 0.8,
		"circle-color": [
			"match",
			["get", "degree_of_crash___detailed"],
			"Fatal",
			"#c00000",
			"Serious Injury",
			"#ed7d31",
			"Moderate Injury",
			"#1f3864",
			"Minor/Other Injury",
			"#00b0f0",
			"#ddd"
		],
		"circle-stroke-color": "#ddd",
		"circle-radius": 3.6,
		"circle-stroke-opacity": 0.6
	}
}
